import React, { createContext, useContext, useEffect, useState } from 'react';

const ColorModeContext = createContext();

export function ColorModeProvider({ children }) {
  const [colorMode, setColorModeState] = useState(() => {
    const saved = localStorage.getItem('dd-color-mode');
    // Also check legacy key
    if (!saved) {
      const legacy = localStorage.getItem('chakra-ui-color-mode');
      if (legacy) return legacy;
    }
    if (saved) return saved;

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }

    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(colorMode);
    root.style.colorScheme = colorMode;

    localStorage.setItem('dd-color-mode', colorMode);
    // Keep legacy key for backward compat during migration
    localStorage.setItem('chakra-ui-color-mode', colorMode);
  }, [colorMode]);

  const setColorMode = (mode) => {
    setColorModeState(mode);
  };

  const toggleColorMode = () => {
    setColorModeState((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const value = {
    colorMode,
    setColorMode,
    toggleColorMode,
  };

  return (
    <ColorModeContext.Provider value={value}>
      {children}
    </ColorModeContext.Provider>
  );
}

export function useColorMode() {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error('useColorMode must be used within ColorModeProvider');
  }
  return context;
}

